import React, { useState } from "react";

const AccordionSection = ({ data = null }) => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="accordion-container">
      {data && (
        <>
          {data?.map((item, index) => (
            <div key={index} className="mb-3 border-b rounded-md">
              <div
                role="button"
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeAccordion === index}
                className="relative flex items-center justify-between w-full px-4 py-3 text-left text-black bg-transparent outline-none cursor-pointer"
              >
                <h3 className="lg:text-md text-[18px] font-semibold hover:text-[#1b5df3] dark:text-white">
                  {item?.title}
                </h3>
                <div
                  className={`w-6 h-6 border border-[#d3e0ff] rounded-full flex items-center justify-center transition-transform duration-300 ${
                    activeAccordion === index ? "rotate-180" : ""
                  }`}
                >
                  <span className="block w-3 h-0.5 bg-[#1b5df3]"></span>
                  <span
                    className={`block w-0.5 h-3 bg-[#1b5df3] absolute transition-opacity ${
                      activeAccordion === index ? "opacity-0" : "opacity-100"
                    }`}
                  ></span>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  activeAccordion === index ? "max-h-[1000px] opacity-100 py-2" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-4 text-base text-black dark:text-white">
                  {item?.content && (
                    <div className="text-center font-semibold py-2 text-[18px]">
                      {item?.content}
                    </div>
                  )}
                  {item?.desc1 && <div className="mb-2">{item?.desc1}</div>}
                  {item?.desc2 && <div className="mb-2">{item?.desc2}</div>}
                  {item?.description && <div className="mb-2">{item?.description}</div>}
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default AccordionSection;
